import { endOfDay, startOfDay } from 'date-fns'

// Calendar-day window (local time) containing the given timestamp, in epoch ms.
export function dayBoundsMs(dateMs: number): { start: number; end: number } {
  const date = new Date(dateMs)
  return { start: startOfDay(date).getTime(), end: endOfDay(date).getTime() }
}
